<!--  -->
<template>
  <div class="l-scrool flex justify-start">
    <div class="l-menu" :style="{ width: collapsed ? '80px' : '200px' }">
      <div
        class="l-logo flex-center l-hand-change"
        @click="showMenu()"
        :style="{ width: collapsed ? '80px' : '200px' }"
      >
        <img
          v-if="collapsed"
          style="height: 43px"
          :src="
            shopType == 1
              ? 'https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1579738113163530240.png'
              : 'https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481874388440715264.png'
          "
          alt=""
        />
        <img
          v-else
          style="width: 164px"
          :src="
            shopType == 1
              ? 'https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1579736878473678848.png'
              : 'https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1481874420464226304.png'
          "
          alt=""
        />
      </div>
      <div class="l-ment-list margin-top-xs">
        <a-menu
          :default-selected-keys="[defaultSelectKeys]"
          :inline-collapsed="collapsed"
          :default-open-keys="[defaultOpenKeys]"
          :selectedKeys="[defaultSelectKeys]"
          mode="inline"
          theme="light"
          @click="clickMenu"
          @openChange="openChange"
        >
          <a-sub-menu
            v-for="(item, index) of menuRouter"
            :key="item.value"
            :ks="index"
          >
            <span slot="title"
              ><a-icon
                :type="item.icon"
                style="font-size: 18px; color: white"
              /><span>{{ item.lable }}</span></span
            >
            <a-menu-item
              v-for="(it, idx) of item.children"
              :key="it.value"
              :ks="idx"
            >
              {{ it.lable }}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
    </div>
    <div
      class="l-container"
      :style="{ width: `calc(100% - ${collapsed ? '80' : '200'}px)` }"
    >
      <div class="l-header padding-lr-26 flex justify-end align-top">
        <div class="l-right flex justify-end align-center">
          <div class="text-green900 flex margin-left-" @click="amallIndex">
            <div class="padding-6 text-16 text-bold">
              {{ shopType == 1 ? "A猫商城商户端首页" : "艾工单首页" }}
            </div>
            <div class="flex-center">
              <a-icon
                type="home"
                class="text-bold"
                style="color: text-green900; font-size: 16px"
              />
            </div>
          </div>
          <!-- 用户名 -->
          <div class="amall-vertical-line margin-lr-sm"></div>
          <div
            class="flex justify-center align-top margin-right-sm"
            @click="openMessage"
            v-if="shopType == 1"
          >
            <div class="h-message-left justify-center align-center">消息</div>
            <div class="h-message-icon flex justify-center align-center">
              <img class="h-icon" src=".././assets/icon/message.png" />
            </div>
            <div class="h-message-right flex justify-center align-center">
              <a-badge :count="allNum" show-zero> </a-badge>
            </div>
          </div>
          <div class="flex-center">
            <div
              class="amall-img-center round"
              style="width: 50px; height: 50px; margin-right: 10px"
            >
              <img
                v-if="shopInfo.shopIco"
                style="width: 50px"
                :src="shopInfo.shopIco"
                alt=""
              />
            </div>
            <a-dropdown>
              <a
                class="ant-dropdown-link text-black"
                @click="(e) => e.preventDefault()"
              >
                {{ shopInfo.shopName }}
                <a-icon
                  type="caret-down"
                  class="text-bold"
                  style="color: var(--amall-green)"
                />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <div href="javascript:;" @click="loginOut">退出登录</div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div class="amall-vertical-line margin-lr-sm"></div>
          <!-- 客服 -->
          <div class="text-black text-16" @click="visible = true">
            客服
            <a-icon
              type="customer-service"
              style="color: var(--amall-green); font-size: 16px"
            />
          </div>
        </div>
      </div>
      <div class="l-main padding-xs">
        <div class="l-content" ref="content">
          <router-view />
        </div>
      </div>
    </div>
    <amallService :visible="visible" @cancel="visible = false"></amallService>
    <my-loading
      :scrollWidth="offsetWidth"
      :loading="$store.state.loading"
    ></my-loading>
    <!-- 消息列表弹窗 -->
    <div>
      <a-drawer
        title="消息通知列表"
        width="600"
        placement="right"
        :visible="visibleMessage"
        :headerStyle="{
          background: 'var(--amall-green)',
          height: '50px',
        }"
        :destroyOnClose="true"
        :bodyStyle="{ padding: 0 }"
        @close="onClose"
      >
        <div
          class="amall-container-drawer"
          :style="{ height: $store.state.visibleHeight + 69 + 'px' }"
        >
          <div
            class="amall-content-box"
            :style="{ height: $store.state.visibleHeight - 37 + 'px' }"
          >
            <div class="h-clear-box flex justify-start align-center">
              <div class="h-clear flex justify-center align-center">
                <img class="h-clear-icon" src=".././assets/icon/clear.png" />
              </div>
              <div class="h-clear-text" @click="allRead_site">全部已读</div>
            </div>
            <!-- 消息通知 -->
            <div
              class="
                h-mage
                amall-drawer-title
                text-20 text-bold
                padding-bottom-xxxl
              "
            >
              <div
                class="h-ever-message"
                v-for="(item, index) of listMessage"
                :key="index"
                @click="skip(item)"
              >
                <div class="h-left-top flex justify-start align-center">
                  <div class="h-top flex justify-start align-center">
                    <div class="h-icon-box flex justify-start align-top">
                      <div
                        class="h-icon flex justify-start align-center"
                        v-if="item.type >= 1 && item.type <= 4"
                      >
                        <img class="h-img" src=".././assets/icon/icon1.png" />
                      </div>
                      <div
                        class="h-icon flex justify-start align-center"
                        v-if="item.type > 4 && item.type <= 18"
                      >
                        <img class="h-img" src=".././assets/icon/icon2.png" />
                      </div>
                      <div
                        class="h-icon flex justify-start align-center"
                        v-if="item.type > 18 && item.type <= 23"
                      >
                        <img class="h-img" src=".././assets/icon/icon3.png" />
                      </div>
                      <div
                        class="h-icon flex justify-start align-center"
                        v-if="item.type > 23 && item.type <= 25"
                      >
                        <img class="h-img" src=".././assets/icon/icon4.png" />
                      </div>
                      <div class="h-unread" v-if="item.status != 1"></div>
                    </div>
                    <div class="h-type">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="h-right">{{ item.createTime }}</div>
                </div>
                <div class="h-bottom">{{ item.message }}</div>
              </div>
              <div
                class="h-more"
                @click="addMore"
                v-if="listMessage.length >= 10"
              >
                <div class="h-text">点击加载更多</div>
              </div>
              <div class="h-all" v-if="is">
                <div class="h-text1">已全部加载完成</div>
              </div>
            </div>
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>

<script>
import * as utils from "@/utils/utils";
import menuRouter from "../router/components";
import amallService from "@/components/alerts/amallService.vue";
import { shop_message } from "@/service/shop_h.js";
import { getOrderDetail } from "@/service/order.js";
import { addColor } from "../utils/addColor.js";
import { messageList, allRead, everRead, allNoRead } from "@/service/user_h.js";
import qs from "qs";
export default {
  name: "",
  components: {
    amallService,
  },
  data() {
    return {
      adminName: "",
      menuRouter: [],
      defaultSelectKeys: "",
      defaultOpenKeys: "",
      shopInfo: {},
      visible: false,
      selectedKeys: [],
      collapsed: false,
      offsetWidth: 0,
      shopType: 1,
      visibleMessage: false,
      listMessage: [],
      allNum: "",
      pageSize: 10,
      pageNum: "1",
      allMessage: "",
      is: false,
      id: "",
      messageId: "",
    };
  },
  created() {
    utils.editMenuList(menuRouter, (res, shopType) => {
      this.menuRouter = res;
      this.shopType = shopType;
      addColor(shopType); //根据角色修改主题皮肤
      if (localStorage.getItem("amall_defult_select_keys")) {
        this.defaultSelectKeys = localStorage.getItem(
          "amall_defult_select_keys"
        );
        this.defaultOpenKeys = localStorage.getItem("amall_defult_open_keys");
        this.$router.push(this.defaultSelectKeys);
      } else {
        this.defaultSelectKeys = this.menuRouter[0].children[0].value;
        this.defaultOpenKeys = this.menuRouter[0].value;
        this.$router.push(this.defaultSelectKeys);
      }
      this.getShopInfo();
    });
    this.newNum();
    // 请求未读消息的数量
    this.unreadMessage();
  },
  methods: {
    unreadMessage() {
      allNoRead().then((res) => {
        if (res.flag) {
          this.allNum = res.data;
        }
      });
    },
    getShopInfo() {
      shop_message().then((res) => {
        this.shopInfo = res.data;
      });
    },
    openChange(e) {},
    clickMenu({ item, key, keyPath }) {
      this.defaultSelectKeys = keyPath[0];
      this.defaultOpenKeys = keyPath[1];
      localStorage.setItem("amall_defult_select_keys", this.defaultSelectKeys);
      localStorage.setItem("amall_defult_open_keys", this.defaultOpenKeys);
      localStorage.removeItem("saveProductPageStatus"); //切换页面时，删除存储商品管理选中的状态
      this.$router.push(this.defaultSelectKeys);
    },
    amallIndex() {
      localStorage.setItem(
        "amall_defult_select_keys",
        this.menuRouter[0].children[0].value
      );
      localStorage.setItem("amall_defult_open_keys", this.menuRouter[0].value);
      this.defaultSelectKeys = this.menuRouter[0].children[0].value;
      this.defaultOpenKeys = this.menuRouter[0].value;
      this.$router.push(this.defaultSelectKeys);
    },
    showMenu() {
      this.collapsed = !this.collapsed;
      this.getScroolInfo();
    },
    getScroolInfo() {
      this.$store.commit(
        "SET_VISIBLE_HEIGHT",
        this.$refs.content.offsetHeight - 20
      );
      this.$store.commit(
        "SET_VISIBLE_WIDTH",
        this.$refs.content.offsetWidth - 20
      );
      this.offsetWidth = this.collapsed ? 80 : 200;
      this.$store.commit("SET_SEARCH_HEIGHT", 100);
      this.$store.commit("SET_PAGINATION_HEIGHT", 64);
      let tableHeight =
        this.$store.getters.GET_VISIBLE_HEIGHT -
        this.$store.getters.GET_SEARCH_HEIGHT -
        this.$store.getters.GET_PAGINATION_HEIGHT;
      this.$store.commit("SET_TABLE_HEIGHT", tableHeight);
    },
    loginOut() {
      localStorage.removeItem("amall_authorization");
      localStorage.removeItem("amall_defult_open_keys");
      localStorage.removeItem("amallSystemId");
      localStorage.removeItem("amallShopType");
      localStorage.removeItem("amall_defult_select_keys");
      localStorage.removeItem("amallShopInfo");
      if (this.shopType == "1") {
        this.$router.push("/login");
      } else {
        this.$router.push("/demandLogin");
      }
    },

    newNum() {
      var obj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      messageList(obj).then((res) => {
        if (res.flag) {
          this.allMessage = res.data.recordCount;
        } else {
          this.listMessage = [];
        }
      });
    },
    // 请求消息列表
    news() {
      var obj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      messageList(obj).then((res) => {
        if (res.flag) {
          this.listMessage = res.data.smallList;
          this.allMessage = res.data.recordCount;
        } else {
          this.listMessage = [];
        }
      });
    },
    skip(item) {
      console.log(item)
      this.id = item.projectOrderSn;
      this.messageId = item.id;
      var that = this;
      if (item.status == 2) {
        everRead(
          qs.stringify({
            id: item.id,
          })
        ).then((res) => {
          console.log(res);
          this.news();
        });
      }
      if (4 >= item.type >= 1) {
        this.$router.push(
          "/control_order?saleOrderSn=" +
            item.saleOrderSn +
            "&visible=" +
            1 +
            "&messageId=" +
            item.id
        );
        // this.visibleMessage = false;
        // 订单详情页
      } else if (
        item.type == 25 ||
        item.type == 7 ||
        item.type == 8 ||
        item.type == 9 ||
        item.type == 10 ||
        item.type == 17
      ) {
        this.$router.push(
          "/control_project?projectOrderSn=" +
            this.id +
            "&visible=" +
            2 +
            "&messageId=" +
            this.messageId
        );
        // this.visibleMessage = false;
        //项目详情页
      } else if (item.type == 11 || item.type == 12 || item.type == 14) {
        this.$router.push(
          "/control_project?projectOrderSn=" +
            this.id +
            "&visible=" +
            2 +
            "&messageId=" +
            this.messageId
        );
        // this.visibleMessage = false;
        // 进场详情页
      } else if (item.type == 13) {
        this.$router.push(
          "/control_project?projectOrderSn=" +
            this.id +
            "&visible=" +
            2 +
            "&messageId=" +
            this.messageId
        );
        // this.visibleMessage = false;
        // 记录详情页
      } else if (item.type == 15) {
        this.$router.push(
          "/control_project?projectOrderSn=" +
            this.id +
            "&visible=" +
            2 +
            "&messageId=" +
            this.messageId
        );
        // this.visibleMessage = false;
        // 任务完成详情页
      } else if (item.type == 16) {
        this.$router.push(
          "/control_project?projectOrderSn=" +
            this.id +
            "&visible=" +
            2 +
            "&messageId=" +
            this.messageId
        );
        // this.visibleMessage = false;
        // 项目验收详情页
      } else {
        everRead({ id: item.id }).then((res) => {
          console.log(res);
        });
      }
    },
    // 点击把所有未读消息设置位已读
    allRead_site() {
      allRead().then((res) => {
        if (res.flag) {
          this.news();
          this.unreadMessage();
        }
      });
    },
    openMessage() {
      if (this.allMessage > 0) {
        this.visibleMessage = true;
        this.news();
      } else {
        this.visibleMessage = false;
      }
    },
    onClose() {
      this.visibleMessage = false;
    },
    // 点击加载更多
    addMore() {
      this.pageSize = this.pageSize + 10;
      if (this.pageSize >= this.allMessage) {
        this.is = true;
      }
      this.news();
    },
  },
  mounted() {
    var clientWidth = document.documentElement.clientWidth;
    if (clientWidth < 1200) {
      this.collapsed = true;
    } else {
      this.collapsed = false;
    }
    this.getScroolInfo();
    window.onresize = utils.debounce((res) => {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth < 1200) {
        this.collapsed = true;
      } else {
        this.collapsed = false;
      }
      this.getScroolInfo();
    }, 100);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollBottom);
  },
};
</script>
<style scoped lang='scss'>
.l-scrool {
  background: #f4f5f9;
}
.l-menu {
  height: 100vh;
  width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #252733;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  transition: all 0.16s linear;
  .l-logo {
    width: 200px;
    height: 80px;
    border-bottom: 1px solid #2f313d;
  }
}
.l-container {
  height: 100vh;
}
.l-main {
  min-width: 1000px;
  height: calc(100% - 80px);
}
.l-header {
  min-width: 1000px;
  height: 80px;
  background: var(--amall-white);
  padding: 0 37px;
  box-sizing: border-box;
  cursor: pointer;
}
.h-clear-box {
  margin-left: 20px;
  margin-top: 10px;
  .h-clear {
    width: 13px;
    height: 13px;
    overflow: hidden;
    .h-clear-icon {
      width: 13px;
      height: 13px;
    }
  }
  .h-clear-text {
    margin-left: 4px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #b2b2b2;
    opacity: 1;
    cursor: pointer;
  }
}
.h-message {
  padding: 7px 26px 6px 27px;
  background: #05d6c9;
  opacity: 1;
  border-radius: 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  opacity: 1;
}
.h-more {
  width: 600px;
  text-align: center;
  background: #fff;
  padding: 15px 0;
  position: fixed;
  right: 0;
  bottom: 0;

  .h-text {
    margin: 0 auto;
    width: 140px;
    height: 40px;
    line-height: 40px;
    background: #05d6c9;
    text-align: center;
    border-radius: 4px;
    color: #f4f5f9;
    cursor: pointer;
  }
}
.h-message-left {
  width: 32px;
  height: 53px;
  text-align: center;
  line-height: 53px;
}
.h-message-icon {
  margin-left: 5px;
  .h-icon {
    width: 17px;
    height: 17px;
  }
}
.h-message-right {
  height: 30px;
}
.h-all {
  width: 600px;
  text-align: center;
  background: #fff;
  padding: 15px 0;
  position: fixed;
  right: 0;
  bottom: 0;
  .h-text1 {
    margin: 0 auto;
    width: 140px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    text-align: center;
    border-radius: 4px;
    font-size: 18px;
    color: #b2b2b2;
    cursor: pointer;
  }
}
.h-mage {
  margin-left: 20px;
  .h-ever-message {
    width: 560px;
    padding: 15px 20px 9px 20px;
    margin-top: 20px;
    border: 1px solid #e9e9e9;
    cursor: pointer;
    .h-left-top {
      .h-top {
        .h-icon {
          width: 30px;
          height: 30px;
          overflow: hidden;
          .h-img {
            width: 30px;
            height: auto;
          }
        }
        .h-unread {
          width: 7px;
          height: 7px;
          background: #fe473a;
          border-radius: 50%;
          opacity: 1;
        }
        .h-type {
          margin-left: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 0px;
          color: #b2b2b2;
          opacity: 1;
        }
      }
      .h-right {
        margin-left: 6px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #b2b2b2;
        opacity: 1;
      }
    }
    .h-bottom {
      margin-left: 38px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #383838;
      opacity: 1;
    }
  }
}
.l-content {
  min-width: 1000px;
  height: calc(100%);
  background: #ffffff;
  overflow: auto;
  border-radius: 12px;
}
.l-ment-list >>> .ant-menu {
  background: #252733 !important;
}
.l-ment-list >>> .ant-menu-item,
.l-ment-list >>> .ant-menu-submenu-title {
  width: 100%;
  color: rgba(255, 255, 255, 0.4);
  height: 74px !important;
  line-height: 74px !important;
  font-size: 18px !important;
  text-align: left;
  transition: all 0.16s ease-in-out;
}
.ant-menu-submenu-selected,
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  background: #2f313d !important;
}
.ant-menu-submenu-open >>> .ant-menu-submenu-selected {
  background: transparent !important;
}

.l-ment-list >>> .ant-menu-item-selected {
  border-left: 7px solid #FEB900;
  box-sizing: border-box;
  padding-left: 48px !important;
  color: #FEB900 !important;
  font-weight: 600;
  background: #2f313d !important;
}
.ant-menu-item::after,
.ant-menu-item-selected::after {
  border-left: none;
  opacity: 0;
}
.ant-menu-item-active,
.ant-menu-submenu-active {
  background: #2f313d !important;
}
.ant-menu-inline .ant-menu-item:after,
.ant-menu-vertical-left .ant-menu-item:after,
.ant-menu-vertical-right .ant-menu-item:after,
.ant-menu-vertical .ant-menu-item:after {
  border-left: none !important;
  opacity: 0 !important;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  background: #252733;
  border: none;
}
.amall-vertical-line {
  width: 0px;
  height: 14px;
  border-left: 2px solid #dbdbdb;
  opacity: 1;
}

/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  /**/
}

/* 滑动条样式设置 */
div::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 2px;
}

div::-webkit-scrollbar-thumb {
  background: rgba(239, 239, 239, 0.21);
  border-radius: 6px;
}

div::-webkit-scrollbar-thumb:hover {
  background: rgba(200, 200, 200, 1);
}

div::-webkit-scrollbar-corner {
  background: rgba(200, 200, 200, 0.21);
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue